import * as ActionTypes from '../constants/actionTypes'
import { apiClient } from '../lib';
import * as administratorActions from './administrators'
import store from '../store'

export const set = async(key, params = {})=>{
  store.dispatch({ 
    type: 'set',
    key,
    payload: params
  })
}


// WEBPACK FOOTER //
// ./src/actions/config.js